export default "__VITE_ASSET__CEhSNRKd__"